export const legalProfileTypes = {
    grower: {
        name: "Grower",
    },
    "wholesale-buyer": {
        name: "Wholesale Buyer",
    },
    coop: {
        name: "Coop / Flower Exchange",
    },
    "retail-buyer": {
        name: "Retail Buyer",
    },
};
export const makeProfileRoute = (profile) => `/${profile.type}s/${(profile === null || profile === void 0 ? void 0 : profile.slug) || profile._id}`;
//# sourceMappingURL=profiles.js.map